import { render } from "./BlockLink.vue?vue&type=template&id=180f0932"
import script from "./BlockLink.vue?vue&type=script&lang=js"
export * from "./BlockLink.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/bezbedno/admin/static/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"js/Components/BlockEditors/BlockLink.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "180f0932"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('180f0932', __exports__)) {
    console.log('reload')
    api.reload('180f0932', __exports__)
  }
  
  module.hot.accept("./BlockLink.vue?vue&type=template&id=180f0932", () => {
    console.log('re-render')
    api.rerender('180f0932', render)
  })

}


export default __exports__